import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import FooterItem from './item'
interface IFooterProps {
    menus: Array<IMenu>
}
interface IMenu {
    title: string
    icon: string
    activeIcon: string
    route: string
    isMain?: boolean
    main: boolean
    role: string
}

const Footer = ({ menus }: IFooterProps) => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const isFund: boolean = pathname.includes('funds')
    return (
        <>
            {isFund && (
                <div
                    aria-label="ساخت صندوق"
                    // Offset by the safe area as well as the nav height: the nav
                    // grows by that inset, so a flat 88px lets the button drift
                    // into it wherever the inset is non-zero.
                    className="cursor-pointer fixed bottom-[calc(88px+var(--safe-bottom))] right-4 z-30 bg-green-1 rounded-full text-white w-14 h-14 flex items-center justify-center shadow-fab active:scale-95 md:right-[37%]"
                    onClick={() => navigate('/add-box/moneyPool')}
                >
                    <span className="text-3xl leading-none -mt-1">+</span>
                </div>
            )}
            <div className="md:px-[35%] md:bg-bg-md-screen fixed bottom-0 left-0 w-full z-20">
                <div className="bg-white shadow-nav border-t border-black/5 rounded-t-2xl pb-[var(--safe-bottom)]">
                    <div className="flex justify-around items-stretch relative">
                        {React.Children.toArray(
                            menus.map((item) => (
                                <FooterItem
                                    role={item.role}
                                    isMain={item?.isMain}
                                    title={item?.title}
                                    icon={item?.icon}
                                    router={item?.route}
                                    isActive={pathname.includes(item.route)}
                                    main={item.main}
                                    activeIcon={item.activeIcon}
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
